import { BrandLoadingScreen } from "@/components/Layout/BrandLoadingScreen/BrandLoadingScreen";

export const FullScreenLoadingSpinner = ({ message }: { message: string }) => (
  <BrandLoadingScreen message={message} />
);
